module.exports = __webpack_public_path__ + "assets/img/smartRightBottomContentBg.3a73e071.png";